export default "__VITE_ASSET__BmyKPTcg__"